import { DestroyRef, Injectable, inject, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ConnectivityService {
  private readonly destroyRef = inject(DestroyRef);

  readonly online = signal(
    typeof navigator === 'undefined' ? true : navigator.onLine
  );

  constructor() {
    if (typeof globalThis.addEventListener !== 'function') {
      return;
    }

    const markOnline = () => this.online.set(true);
    const markOffline = () => this.online.set(false);

    globalThis.addEventListener('online', markOnline);
    globalThis.addEventListener('offline', markOffline);
    this.destroyRef.onDestroy(() => {
      globalThis.removeEventListener('online', markOnline);
      globalThis.removeEventListener('offline', markOffline);
    });
  }
}
